export default __webpack_public_path__ + "static/media/outdoor_poster_reduced.d7f27577.jpg";